import React from 'react';
import PropTypes from 'prop-types';

/**
 * Footer
 */
class Footer extends React.Component {

  constructor(props) {
    super(props);
    this.handleOpenHelpClick = this.handleOpenHelpClick.bind(this);
    this.handleOpenMenuClick = this.handleOpenMenuClick.bind(this);
    this.handleOpenSortModalClick = this.handleOpenSortModalClick.bind(this);
  }

  handleOpenHelpClick() {
    $('#help_modal').show();
  }

  handleOpenMenuClick() {
    $('#menu_page').show();
  }

  handleOpenSortModalClick() {
    $('#sort_menu_modal').show();
  }


  render() {
    let sortIconClass = 'sort_btn_icon_desc';
    if (this.props.sortOrder == 'asc') {
      sortIconClass = 'sort_btn_icon_asc';
    }

    return (
      <footer id="footer">
        <div className="clearfix footer_wrap_mobile">
          <div className="help_btn_area"  onClick={e => this.handleOpenHelpClick(e)} >
            <span className="help_img" />
          </div>
          <div className="sort_menu_open_area_simple footer_item_border_default" onClick={e => this.handleOpenSortModalClick(e)}>
            <span className="sort_content_text">{this.props.sortLabel}</span>
          </div>
          <div className="sort_btn_area footer_item_border_default">
            <span className={sortIconClass} onClick={e => this.props.changeSortOrder(e)} />
          </div>
          <div className="menu_btn_open_area footer_item_border_default" onClick={e => this.handleOpenMenuClick(e)} >
            <span className="menu_btn_open_icon" />
          </div>
        </div>
        <div className="copyright_area">
          <span className="copyright_txt">Copyright © 2018 KITADENSHI CORPORATION All rights reserved.</span>
        </div>
      </footer>
    );
  }
}

Footer.propTypes = {
  sortLabel: PropTypes.any.isRequired,
  sortOrder: PropTypes.any.isRequired,
};

export default Footer;
